export default "__VITE_ASSET__DacsV9Jp__"